@if (documentationAdded()) {
  <div class="ga-documentation-note body-bold">
    <i
      nz-icon
      nzType="icons:check-circle-filled-transparent"
      class="svg-icon"
    ></i>
    <span>{{ i18n.langString("add_documentation_success") }}</span>
  </div>
}

<div
  class="notification-alert"
  [class.notificationlist]="notificationList()"
  [class.singleAsset]="!notificationList()"
  [class.redBG]="Critical() && !InActive()"
  [class.greyBG]="InActive()"
  [class.yellowBG]="Warning()"
  [class.greenBG]="Working()"
  [class.falseAlert]="falseAlert()"
>
  @if (notification(); as notification) {
    <div
      class="notification-alert-content"
      (click)="onAssetName()"
      (keydown)="onAssetName()"
      [class.mobile]="isMobile()"
      [class.tablet]="isTablet()"
      [class.desktop]="isDesktop()"
      tabindex="0"
    >
      <h2 class="alerttitle">
        {{ i18n.parse(notification.measurementTitle) }}
      </h2>

      <div class="alert-content">
        @if (InActive()) {
          <i nz-icon nzType="icons:cross-circle" class="svg-icon fillwhite"></i>
        }
        @if (Working()) {
          <i nz-icon nzType="icons:check-circle" class="svg-icon fillwhite"></i>
        }
        @if (Critical() && !InActive()) {
          <i
            nz-icon
            nzType="icons:status-exclamation-triangle"
            class="svg-icon fillwhite"
          ></i>
        }
        @if (Warning()) {
          <i
            nz-icon
            nzType="icons:status-exclamation-octagon"
            class="svg-icon"
          ></i>
        }

        <span class="alert-content-message"
          >{{ Message() }} {{ Instructions() }}</span
        >

        @if (!isRotate()) {
          <div class="clickable-arrow">
            <i
              nz-icon
              nzType="icons:right_click_arrow"
              class="svg-icon"
              [class.fillwhite]="InActive() || Critical() || Working()"
            ></i>
          </div>
        }
      </div>

      <div class="alert-content">
        <div class="alert-values">
          @if (notificationList() && InActive()) {
            <span>
              {{ i18n.langString("in_active_notification_msg") }}
              {{ notification.timestamp | date: "medium" }}
            </span>
          }
          @if (
            notificationList() &&
            notification.value !== null &&
            !InActive() &&
            !Warning() &&
            !Critical() &&
            isRotate()
          ) {
            <span>
              {{ i18n.langString("measured_value") }}
              <span class="nowrap">{{ Value() }}</span>
            </span>
          }
          @if (
            notification.value !== null &&
            notification.prevValue !== null &&
            !InActive() &&
            !Warning() &&
            !Critical() &&
            isRotate()
          ) {
            <span>
              {{ i18n.langString("increased_value") }}
              <span class="nowrap">{{ ValueIncrease() }}</span>
            </span>
          }
        </div>
      </div>
    </div>

    @if (!notificationList()) {
      <div class="buttonwrapperwrapper">
        @if (notification.equipmentType !== "Rotating Equipment") {
          <div class="buttonwrapper">
            <app-nav-button
              [primary]="true"
              svgIcon="icons:documentation"
              (clickEvent)="overlayDocumentation.set(true)"
            >
              {{ i18n.langString("add_documentation") }}
            </app-nav-button>
          </div>
        }
      </div>
    }

    <div class="timestampwrapper">
      <span class="timestamp"
        >{{ i18n.langString("detected_on") }}:
        {{ notification.timestamp | date: dateFormatString() }}</span
      >
    </div>

    @if (overlayDocumentation()) {
      <app-docu-wizard
        [assetId]="notification.objectID"
        [sensorId]="notification.sensorID"
        (closeEvent)="overlayDocumentation.set(false)"
        (saved)="onDocumentationAdded()"
      >
      </app-docu-wizard>
    }

    @if (overlayInstructions()) {
      <app-sensor-instruction
        (close)="overlayInstructions.set(false)"
      ></app-sensor-instruction>
    }
  }
</div>
